import { render } from "./ProgrammeCommitteForm.vue?vue&type=template&id=5d6fb840"
import script from "./ProgrammeCommitteForm.vue?vue&type=script&lang=js"
export * from "./ProgrammeCommitteForm.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__